// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type AiChatSessionsQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['ID']['input'];
  scopeType?: Types.InputMaybe<Types.AiChatScopeType>;
  scopeDocumentCollectionId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type AiChatSessionsQuery = { __typename?: 'Query', aiChatSessions: Array<{ __typename?: 'AiChatSession', id: string, workspaceId: string, scopeType: Types.AiChatScopeType, status: Types.AiChatSessionStatus, scopeDocumentCollectionId?: string | null, title: string, createdAt: any, updatedAt: any }> };


export const AiChatSessionsDocument = gql`
    query AiChatSessions($workspaceId: ID!, $scopeType: AiChatScopeType, $scopeDocumentCollectionId: ID) {
  aiChatSessions(
    workspaceId: $workspaceId
    scopeType: $scopeType
    scopeDocumentCollectionId: $scopeDocumentCollectionId
  ) {
    id
    workspaceId
    scopeType
    status
    scopeDocumentCollectionId
    title
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useAiChatSessionsQuery__
 *
 * To run a query within a React component, call `useAiChatSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiChatSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiChatSessionsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      scopeType: // value for 'scopeType'
 *      scopeDocumentCollectionId: // value for 'scopeDocumentCollectionId'
 *   },
 * });
 */
export function useAiChatSessionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AiChatSessionsQuery, AiChatSessionsQueryVariables> & ({ variables: AiChatSessionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiChatSessionsQuery, AiChatSessionsQueryVariables>(AiChatSessionsDocument, options);
      }
export function useAiChatSessionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiChatSessionsQuery, AiChatSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiChatSessionsQuery, AiChatSessionsQueryVariables>(AiChatSessionsDocument, options);
        }
// @ts-ignore
export function useAiChatSessionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiChatSessionsQuery, AiChatSessionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiChatSessionsQuery, AiChatSessionsQueryVariables>;
export function useAiChatSessionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiChatSessionsQuery, AiChatSessionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiChatSessionsQuery | undefined, AiChatSessionsQueryVariables>;
export function useAiChatSessionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiChatSessionsQuery, AiChatSessionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AiChatSessionsQuery, AiChatSessionsQueryVariables>(AiChatSessionsDocument, options);
        }
export type AiChatSessionsQueryHookResult = ReturnType<typeof useAiChatSessionsQuery>;
export type AiChatSessionsLazyQueryHookResult = ReturnType<typeof useAiChatSessionsLazyQuery>;
export type AiChatSessionsSuspenseQueryHookResult = ReturnType<typeof useAiChatSessionsSuspenseQuery>;
export type AiChatSessionsQueryResult = ApolloReactCommon.QueryResult<AiChatSessionsQuery, AiChatSessionsQueryVariables>;